export var findMatchInTableCell = (singleItem, text) => {
  var _a, _b;
  var heading = singleItem.heading,
    infoTagText = singleItem.infoTagText,
    subHeading = singleItem.subHeading,
    ctaText = singleItem.ctaText;
  var items = [heading, infoTagText, subHeading, ctaText];
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    if (item && ((_a = item.toString().toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes((_b = text === null || text === void 0 ? void 0 : text.toLowerCase()) === null || _b === void 0 ? void 0 : _b.trim()))) {
      return item;
    }
  }
};
export var checkValidDate = dateString => {
  return !isNaN(Date.parse(dateString));
};
export var checkFilterDate = (singleItem, tableCellPropForFilter, filterDate) => {
  var formattedFilterDate = new Date(filterDate);
  formattedFilterDate.setHours(0, 0, 0, 0);
  if (checkValidDate(singleItem[tableCellPropForFilter])) {
    var keyDate = new Date(singleItem[tableCellPropForFilter]);
    if (keyDate > formattedFilterDate || keyDate < formattedFilterDate) {
      return false;
    } else {
      return true;
    }
  }
};
export var checkDateInRange = (singleItem, tableCellPropForFilter, filterStartDate, filterEndDate) => {
  var formattedFilterStartDate = new Date(filterStartDate);
  formattedFilterStartDate.setHours(0, 0, 0, 0);
  var formattedFilterEndDate = new Date(filterEndDate);
  formattedFilterEndDate.setHours(0, 0, 0, 0);
  if (!!singleItem[tableCellPropForFilter] && checkValidDate(singleItem[tableCellPropForFilter])) {
    var keyDate = new Date(singleItem[tableCellPropForFilter]);
    if (keyDate < formattedFilterStartDate || keyDate > formattedFilterEndDate) {
      return false;
    } else {
      return true;
    }
  }
};
export var convertToTimestamp = date => {
  return date === null || date === void 0 ? void 0 : date.getTime();
};